var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Organization / File / copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.16602 6.75H1.41602V1.5C1.41602 1.08579 1.7518 0.75 2.16602 0.75H7.41602V1.5H2.16602V6.75ZM11.166 3.75V10.5H4.41602V3.75H11.166ZM4.41602 3H11.166C11.5802 3 11.916 3.33579 11.916 3.75V10.5C11.916 10.9142 11.5802 11.25 11.166 11.25H4.41602C4.0018 11.25 3.66602 10.9142 3.66602 10.5V3.75C3.66602 3.33579 4.0018 3 4.41602 3Z",
    fill: "#2D91E9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon-copy.f77b2aa498b0c2a0060cf77113e8b588.svg";
export { ForwardRef as ReactComponent };